import { EntityModel } from '../EntityModel';
import { SerialisableModel } from '../Model';
export class ClientModel extends SerialisableModel {
    static from(data) {
        return new ClientModel(data);
    }
    get id() {
        return this.data.client_id;
    }
    get name() {
        return this.data.name;
    }
    get entities() {
        return this.data.entities.map((entity) => EntityModel.from(entity));
    }
}
